import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { utilitySetupsRoutes } from './routes';

/** How a setup's bills reach Livable; null while not chosen. */

/** A setup edit waiting for its billing month (LB-6183): the values it applies, from when, and who made it. */

/** A company's setup for one utility type (LB-6182). Enum values come as their names. */

/** A utility's move to another setup, waiting for its billing month (LB-6183). */

/** The setup a property utility follows, or null, and its scheduled move. */

/** A setup as it should be: every value, as the edit route takes it (LB-6183). */

/** What an edit reaches: the utilities that follow the setup, their properties, and how many the caller can't see. */

/** The company setup routes (LB-6182, LB-6183). They answer 404 while isBillingOptionsEnabled is off. */
export class UtilitySetups {
  constructor() {
    _defineProperty(this, "routes", utilitySetupsRoutes);
  }
  /** The company's setups of one utility type, archived ones last. */
  async getCompanySetups(data, options) {
    const resp = await requestService('property').get(this.routes.companySetups(data.companyId), _objectSpread({
      params: {
        utilityTypeId: data.utilityTypeId
      }
    }, options.cancelToken));
    return resp.data;
  }
  async getLink(data, options) {
    const resp = await requestService('property').get(this.routes.link(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * Links the utility to one of its company's setups of the same type: at once when that moves no money, otherwise
   * from the next billing month, which the answer's pendingLink says.
   */
  async link(data, options) {
    const resp = await requestService('property').put(this.routes.link(data.propertyUtilityId), {
      setupId: data.setupId
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** "Make its own setup". With no name, the setup is named after its type ("Water 2"). */
  async fork(data, options) {
    const resp = await requestService('property').post(this.routes.fork(data.propertyUtilityId), {
      name: data.name
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * Changes a setup as a whole (LB-6183): a rename at once, new values at once when no utility that follows it has
   * been billed, and otherwise from the next billing month. With preview, it answers what saving would do and saves
   * nothing.
   */
  async editSetup(data, options) {
    const resp = await requestService('property').put(this.routes.setup(data.setupId), data.draft, _objectSpread(_objectSpread({}, data.preview ? {
      params: {
        preview: true
      }
    } : {}), options.cancelToken));
    return resp.data;
  }

  /** Withdraws the setup's edit that waits for the next billing month, and answers the setup. */
  async cancelPendingEdit(data, options) {
    // delete(url, body, config): no body.
    const resp = await requestService('property').delete(this.routes.pendingEdit(data.setupId), null, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async cancelPendingLink(data, options) {
    // delete(url, body, config): no body.
    const resp = await requestService('property').delete(this.routes.pendingLink(data.propertyUtilityId), null, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}